import { render, staticRenderFns } from "./MyBookingDetail.vue?vue&type=template&id=8f83b71a&"
import script from "./MyBookingDetail.vue?vue&type=script&lang=js&"
export * from "./MyBookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyBookingDetail.vue?vue&type=style&index=0&id=8f83b71a&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f83b71a')) {
      api.createRecord('8f83b71a', component.options)
    } else {
      api.reload('8f83b71a', component.options)
    }
    module.hot.accept("./MyBookingDetail.vue?vue&type=template&id=8f83b71a&", function () {
      api.rerender('8f83b71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyBooking/MyBookingDetail/MyBookingDetail.vue"
export default component.exports